import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

import Theme from "@airasia/phoenix-components/components/Theme"
import UniversalHeader from "@airasia/phoenix-widgets/widgets/UniversalHeader"
import HeroBanner from "@airasia/phoenix-widgets/widgets/HeroBanner"
import UniversalFooter from "@airasia/phoenix-widgets/widgets/UniversalFooter"
import FOOTER_DATA from "../data/footer"
import "./layout.css"
import SEO from "./seo"
import {fireGtmEvent} from "../utils/functions"

const BannerWrapper = styled.div`
  margin-bottom: 16px;

  @media only screen and (min-width: 720px) {
    margin-bottom: 32px;
  }
`

const FooterWrapper = styled.div`
  @media screen and (max-width: 1024px) {
    display: none;
  }
`

const MobileContainer = styled.div`
  @media only screen and (min-width: 768px) {
    display: none;
  }
`

const DesktopContainer = styled.div`
  @media only screen and (max-width: 768px) {
    display: none;
  }
`

const Layout = ({ children, title, description, keywords, bannerData, headerData }) => {
  return (
    <>
      <SEO title={title} description={description} keywords={keywords}/>
      <Theme theme="AIRASIA_CLASSIC">
        <MobileContainer>
          <UniversalHeader
            accessible={true}
            color="greyDarker"
            currency="MYR"
            data={headerData}
            environment="production"
            locale="en-gb"
            viewport="mobile"
          />
          {bannerData && (
            <BannerWrapper>
              <HeroBanner
                device="mobile"
                height="280px"
                selectedBanner={0}
                width="100%"
                bannerDetails={bannerData}
                accessible
                fireGtm={fireGtmEvent}
              />
            </BannerWrapper>
          )}
        </MobileContainer>
        <DesktopContainer>
          <UniversalHeader
            accessible={true}
            color="greyDarker"
            currency="MYR"
            data={headerData}
            environment="production"
            locale="en-gb"
            viewport="desktop"
          />
          {bannerData && (
            <BannerWrapper>
              <HeroBanner
                device="desktop"
                height="280px"
                selectedBanner={0}
                width="100%"
                bannerDetails={bannerData}
                accessible
                fireGtm={fireGtmEvent}
              />
            </BannerWrapper>
          )}
        </DesktopContainer>

        {children}

        <FooterWrapper>
          <UniversalFooter
            accessible
            color="greyDark"
            fontSize="XSmall"
            isChinaDomain={false}
            viewport="desktop"
            data={FOOTER_DATA}
          />
        </FooterWrapper>
      </Theme>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
  description: PropTypes.string,
  keywords: PropTypes.string
}

export default Layout
